import { noop } from 'lodash/fp';
import React from 'react';

import { DocumentFilter } from '../../../shared/filter/DocumentFilter';
import { Filter } from '../../../shared/icons';
import { ModalHeader } from '../../../shared/modal/ModalHeader';
import { Position, PositionModal } from '../../../shared/modal/PositionModal';
import { SearchFilter } from '../../search/store';
import styles from '../Reports.module.scss';

interface TemplateFilterPreviewModalProps {
    isOpen: boolean;
    closeModal: () => void;
    position: Position | null;
    filters: SearchFilter;
    templateName: string;
}

export const TemplateFilterPreviewModal: React.FC<TemplateFilterPreviewModalProps> = ({ closeModal, isOpen, position, templateName, filters }) => {
    const { date: { to, from }, isExclusiveEntityFilter, entityId, includePreExecution, documentNameGroupId, includeRiskOverride, includeRiskScore, includePreferredTerms } = filters;
    return (
        <PositionModal
            isOpen={isOpen}
            position={position}
            closeModal={closeModal}
            testId='document-report-template-filters-preview'
            width='400px'
            maxWidth='400px'
            height='350px'
        >
            <div className={styles.filterPreviewWrapper}>
                <ModalHeader label={`${templateName} Filters`} icon={Filter} />
                <DocumentFilter
                    to={to}
                    from={from}
                    entityId={entityId}
                    isExclusiveEntityFilter={isExclusiveEntityFilter}
                    includePreExecution={includePreExecution}
                    showDocumentNameFilter={false}
                    updateDateFilter={noop}
                    updateFilter={noop}
                    fontSize='14px'
                    documentNameGroupId={documentNameGroupId}
                    includeRiskOverride={includeRiskOverride}
                    includeRiskScore={includeRiskScore}
                    showOverrideRiskFilter
                    showRiskScoreFilter
                    showPreferredTermsFilter
                    includePreferredTerms={includePreferredTerms}
                    disabled
                />
            </div>
        </PositionModal>
    );
};
